export enum OnboardingPage {
  CreateTenant = 'create-tenant',
}
